"use strict";
/*
 * Created on 4. 11. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../../core/utils");

var SettingsChildrenStatsConverter_1 = require("../../../general-settings/conversions/dto/SettingsChildrenStatsConverter");

var SelloutReleaseCategoryPreview_1 = require("../../model/sellout/SelloutReleaseCategoryPreview");

var SelloutReleaseCategoryPreviewConverter_1 = require("./SelloutReleaseCategoryPreviewConverter");
/**
 * <p>Implementation of {@link SelloutReleaseCategoryPreviewConverter}.</p>
 *
 * @author Radek Beran
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SelloutReleaseCategoryPreviewConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseCatego) {
  _inherits(SelloutReleaseCategoryPreviewConverterImpl, _SelloutReleaseCatego);

  function SelloutReleaseCategoryPreviewConverterImpl(settingsChildrenStatsConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseCategoryPreviewConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryPreviewConverterImpl).call(this));
    _this.settingsChildrenStatsConverter = settingsChildrenStatsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseCategoryPreviewConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseCategoryPreview_1.SelloutReleaseCategoryPreview(conversions.documentToClassId(source), conversions.asObject(source, 'releaseId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'categoryId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'includedInRelease', function (v) {
        return utils_1.Utils.asBool(v);
      }), conversions.asObject(source, 'inPathToIncluded', function (v) {
        return utils_1.Utils.asBool(v);
      }), conversions.asObject(source, 'childrenStats', function (doc) {
        return _this2.settingsChildrenStatsConverter.toObject(doc, conversions);
      }), conversions.asObject(source, 'itemsCount', function (v) {
        return utils_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'productsCount', function (v) {
        return utils_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'sitesCount', function (v) {
        return utils_1.Utils.asNumber(v);
      }), conversions.asObject(source, 'itemFilterHash', function (v) {
        return utils_1.Utils.asNumber(v);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      return Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        includedInRelease: source.includedInRelease,
        inPathToIncluded: source.inPathToIncluded,
        childrenStats: this.settingsChildrenStatsConverter.toDocument(source.childrenStats, conversions),
        itemsCount: source.itemsCount,
        productsCount: source.productsCount,
        sitesCount: source.sitesCount,
        itemFilterHash: source.itemFilterHash
      });
    }
  }]);

  return SelloutReleaseCategoryPreviewConverterImpl;
}(SelloutReleaseCategoryPreviewConverter_1.SelloutReleaseCategoryPreviewConverter);

SelloutReleaseCategoryPreviewConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SettingsChildrenStatsConverter_1.SettingsChildrenStatsConverter])], SelloutReleaseCategoryPreviewConverterImpl);
exports.SelloutReleaseCategoryPreviewConverterImpl = SelloutReleaseCategoryPreviewConverterImpl;